@if(text) {
    <div>
    @if((client.isX || client.isL) && text.length < 275 || (client.isM || client.isS) && text.length < 90){
      <div
      class="p2" [innerHTML]="text"></div>
        } @else {
        <div class="overflow-hidden pos-relative">
            <div class="p2"
               [style.height]="currentHeight" 
               [innerHTML]="text"></div>
            <div class="pos-absolute left-0 right-0 bottom-0 "
                 style="height: 12px"
                 [style.background]="currentHeight !== '100%' ? 'linear-gradient(transparent, #211F1E)' : ''"></div>
        </div>
        <div></div>
        <div class="
             bg-col-1
             col-w
             p-t-2">
            <button [buttonStyle]="'text-button'"
                    (click)="toggle()">{{currentHeight === '100%' ? 'View less' : 'View more' | translate}}</button>
        </div>
        }
</div>
}

